export default __webpack_public_path__ + "static/gs-python-code--mobile-deeb0bce7ed11d1bea7f5245ac90520c.webp";